import React, { useState, useEffect } from "react";
import { Switch, Checkbox, Row, Col, Collapse, Radio, Form, Input } from "antd";
// style
import styles from "./form.module.css";

const { Panel } = Collapse;

const QMSForm = ({ disabledState, getFieldValue, setFieldsValue, isAdmin }) => {
  const [solutionAccess, setSolutionAccess] = useState(
    getFieldValue("qms_solution_access"),
  );

  useEffect(() => {
    setSolutionAccess(getFieldValue("qms_solution_access"));
  }, [getFieldValue("qms_solution_access")]);

  const solutionAccessOnChange = (value) => {
    setSolutionAccess((prevState) => !prevState);
    setFieldsValue({ qms_solution_access: value });
  };

  const qmsOnboardingTeamAccessOnChange = (value) => {
    if (value) {
      setFieldsValue({ qms_gm_access: false });
    }
  };
  const qmsGMAccessOnChange = (e) => {
    if (e.target.checked) {
      setFieldsValue({ qms_onboarding_team_access: false });
    }
  };
  return (
    <Collapse defaultActiveKey={["qms_1"]} expandIconPosition="end">
      <Panel header="QMS" key="qms_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Solution Access</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="qms_solution_access"
                  valuePropName="checked"
                >
                  <Switch
                    disabled={disabledState}
                    onChange={solutionAccessOnChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          {isAdmin && (
            <>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Smart Scanning</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={4} xl={6} lg={8} sm={12}>
                        <Form.Item
                          noStyle
                          name="qms_smart_scanning_more_details"
                          valuePropName="checked"
                        >
                          <Checkbox
                            disabled={
                              disabledState ||
                              !getFieldValue("qms_solution_access")
                            }
                          >
                            More Details
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>GM Access</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={2} xl={3} lg={4} sm={6}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="qms_gm_access"
                          valuePropName="checked"
                        >
                          <Checkbox
                            disabled={
                              disabledState ||
                              !getFieldValue("qms_solution_access")
                            }
                            onChange={qmsGMAccessOnChange}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Download Permission</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={2} xl={3} lg={4} sm={6}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="qms_download_permission"
                          valuePropName="checked"
                        >
                          <Checkbox
                            disabled={
                              disabledState ||
                              !getFieldValue("qms_solution_access")
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Onboarding Team Access</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={2} xl={3} lg={4} sm={6}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="qms_onboarding_team_access"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={qmsOnboardingTeamAccessOnChange}
                            disabled={
                              disabledState ||
                              !getFieldValue("qms_solution_access")
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </div>
      </Panel>
    </Collapse>
  );
};

export default QMSForm;
